import { render, staticRenderFns } from "./KSummaryCardPair.vue?vue&type=template&id=1691d6f6&scoped=true&"
import script from "./KSummaryCardPair.vue?vue&type=script&lang=js&"
export * from "./KSummaryCardPair.vue?vue&type=script&lang=js&"
import style0 from "./KSummaryCardPair.vue?vue&type=style&index=0&id=1691d6f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1691d6f6",
  null
  
)

export default component.exports